import { queryOptions, useQuery } from '@tanstack/react-query';

import { stripeApi } from '../api/stripe-api';

import { stripeKeys } from './stripe-keys';

export function applePayDomainsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: stripeKeys.applePayDomains(storeId),
    queryFn: () => stripeApi.applePayDomains(storeId),
  });
}

export function useApplePayDomains(storeId: string) {
  return useQuery(applePayDomainsQueryOptions(storeId));
}
